// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__2hgNi","image":"Card_image__mZXOw","data":"Card_data__CzGeh","key":"Card_key__E5MHM"};